import React, { useRef, useState } from 'react';
import useSound from 'use-sound';

import ChatWindowContainer from './ChatWindowContainer';
import sfxOpenChat from '../assets/sfx/chat_sfx_open.mp3';
import ChatMinimized from './ChatMinimized';

export interface ChatProps {
  uuid: string;
  openByDefault?: boolean;
  collapsible?: boolean;
}

function Chat({ uuid, openByDefault = false, collapsible = true }: ChatProps): JSX.Element {
  const [open, setOpen] = useState(openByDefault);
  const openedYet = useRef(false);
  const [isMinimizing, setIsMinimizing] = useState(false);
  const [play] = useSound(sfxOpenChat);

  // Don't render chat until it's opened, then persist it in the DOM to save the user's scroll location
  if (open) {
    openedYet.current = true;
  }

  const openChat = (): void => {
    setOpen(true);
    play();
    window.parent.postMessage({ method: 'chatOpened' }, '*');
  };

  return (
    <div className="App">
      {openedYet.current ? (
        <ChatWindowContainer
          chatId={uuid}
          open={open}
          onClickMinimize={(): void => {
            setIsMinimizing(true);
            setTimeout(async () => {
              setOpen(false);
              setIsMinimizing(false);
              window.parent.postMessage({ method: 'chatClosed' }, '*');
            }, 250);
          }}
          isMinimizing={isMinimizing}
          collapsible={collapsible}
        />
      ) : null}
      {collapsible && !open && !isMinimizing ? (
        <ChatMinimized openChat={openChat} openedYet={openedYet.current} />
      ) : null}
    </div>
  );
}

export default Chat;
